import { cx } from '@chakra-ui/utils';
import { useContext } from 'react';
import type {
  ControlProps as ReactSelectControlProps,
  OptionTypeBase,
} from 'react-select';

import {
  AssistanceAvailableBackground,
  Flex,
  type FlexProps,
  PopoverAnchor,
} from '@frontend/components';

import { SelectContext } from '../SelectContext';
import { useSelectStyles } from '../SelectStylesContext';
import { BASE_CLASS_NAME } from '../const';

export type ControlProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = ReactSelectControlProps<OptionType, IsMulti> & {
  innerProps: FlexProps;
};

export const Control = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  children,
  innerRef,
  innerProps,
  isFocused = false,
  isDisabled = false,
}: ControlProps<OptionType, IsMulti>) => {
  const { control: controlStyles } = useSelectStyles();
  const { hasSuggestions, hasAcceptedSuggestions, hasRejectedSuggestions } =
    useContext(SelectContext);

  const shouldShowSuggestionsAvailableIcon =
    hasSuggestions &&
    !hasAcceptedSuggestions &&
    !hasRejectedSuggestions &&
    !isDisabled;

  return (
    <PopoverAnchor>
      <Flex
        ref={innerRef}
        __css={controlStyles}
        {...innerProps}
        className={cx(`${BASE_CLASS_NAME}__control`, innerProps.className)}
        {...(isFocused && { 'data-focus': true })}
        {...(isDisabled && { disabled: true })}
        {...(shouldShowSuggestionsAvailableIcon && {
          borderColor: 'interaction.suggestion',
        })}
      >
        {children}
        {shouldShowSuggestionsAvailableIcon ? (
          <AssistanceAvailableBackground />
        ) : null}
      </Flex>
    </PopoverAnchor>
  );
};
